import "./index.less";

import React, { FC, useState } from "react";
// import Logo from "@/layout/image/logo.png";
import { Modal, message } from "antd";

import { useSelector } from "react-redux";

import store from "@/store";
import { TStoreData, TOrgTreeItem } from "@/interface";

const loopChildren = (
  childrenTree: TOrgTreeItem,
  list: TOrgTreeItem[],
  parentNames = ""
) => {
  childrenTree?.children?.forEach((child) => {
    if (!child.hasRelation && Array.isArray(child.children)) {
      loopChildren(child, list, (parentNames += "/" + child.orgName));
    } else {
      list.push(child);
    }
  });
  return list;
};

let timer: any = null;
const waitTime = 300; // 该时间间隔内点击才算连续点击（单位：ms）
let lastTime = new Date().getTime(); // 上次点击时间
let count = 0; // 连续点击次数

const SelectOrigin: FC = () => {
  const storeData = useSelector((data: TStoreData) => {
    return {
      orgTree: data.orgTree,
      orgActive: data.orgActive,
    };
  });

  const { orgTree, orgActive } = storeData;
  const orgList = loopChildren(orgTree, [], orgTree.orgName);

  const [visible, setVisible] = useState(false);
  const [orgSelect, setOrgSelect] = useState<TOrgTreeItem>(orgActive);

  const handleClickLogo = (): void => {
    const currentTime = new Date().getTime();
    // 计算两次相连的点击时间间隔
    count = currentTime - lastTime < waitTime ? count + 1 : 1;
    lastTime = new Date().getTime();
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);

      if (count > 4) {
        // 点击超过五下事件
        toggleVisible();
      } else {
        // 正常点击事件
        console.log("走正常点击事件");
      }
    }, waitTime + 10);
  };

  const toggleVisible = () => {
    setVisible(!visible);

    // 如果关闭弹框，则恢复选中
    if (visible) {
      setOrgSelect(orgActive);
    }
  };

  // 确认选中组织
  const saveOrigin = () => {
    store.dispatch({
      type: "setOrgActive",
      value: {
        tenantCode: orgSelect?.tenantCode,
        orgCode: orgSelect?.orgCode,
      },
    });

    if (orgSelect?.tenantCode !== orgActive.tenantCode) {
      window.location.href = "/home";
    } else {
      message.warn("组织未改变！");
      setVisible(false);
    }
  };

  const renderSelectList = () => {
    return (
      <>
        {orgList.map((org) => (
          <div
            onClick={() => {
              setOrgSelect(org);
            }}
            className={`select_org_item ${
              orgSelect?.tenantCode === org.tenantCode
                ? "select_org_item_act"
                : ""
            }`}
            key={org.orgCode}
          >
            {/* <img src={Logo} className="select_org_icon" alt="" /> */}
            <span className="select_org_word">{org.orgName}</span>
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      {/* <img
        className="lr-layout-logo"
        src={Logo}
        alt="logo"
        onClick={handleClickLogo}
      /> */}

      <Modal
        title="请选择组织"
        okText={`确定`}
        cancelText={`取消`}
        visible={visible}
        onOk={saveOrigin}
        onCancel={toggleVisible}
      >
        {renderSelectList()}
      </Modal>
    </>
  );
};

export default SelectOrigin;
